export default "__VITE_ASSET__5bNI4Kyg__"